module.exports = __webpack_public_path__ + "static/media/sidebar-dashboard.696e5dfd.svg";